// components/PhoneSignIn.jsx
//
// This is the PHONE NUMBER sign-in widget (different from
// PhoneEmailVerify.jsx, which verifies an email address instead).
// Uses phone.email's sign_in_button_v1.js script and your real client ID.
//
// Same security pattern as the email version: phone.email calls our
// global `phoneEmailListener` function with a `user_json_url`. We send
// ONLY that URL to our backend, which fetches it server-side and pulls
// out the verified phone number + name - never trusting anything sent
// directly from the browser for this.

import { useEffect } from 'react';

const CLIENT_ID = '15695407177920574360'; // your real phone.email client ID
import { API_BASE } from '../config';

function PhoneSignIn({ onVerified, onError }) {
  useEffect(() => {
    const container = document.querySelector('.pe_signin_button');

    const script = document.createElement('script');
    script.src = 'https://www.phone.email/sign_in_button_v1.js';
    script.async = true;
    container?.appendChild(script);

    // phone.email calls this exact function name when phone verification succeeds
    window.phoneEmailListener = async (userObj) => {
      try {
        const res = await fetch(`${API_BASE}/auth/phone-signin-verify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_json_url: userObj.user_json_url }),
        });

        const data = await res.json();

        if (!res.ok) {
          onError?.(data.message || 'Phone verification failed.');
          return;
        }

        onVerified(data);
      } catch (err) {
        onError?.('Could not verify phone number. Please try again.');
      }
    };

    return () => {
      window.phoneEmailListener = null;
    };
  }, [onVerified, onError]);

  return <div className="pe_signin_button" data-client-id={CLIENT_ID}></div>;
}

export default PhoneSignIn;
